export default __webpack_public_path__ + "static/JosefinSans-Light-3718ee1df33f72f0804086eb3750c416.woff2";